import { render } from "./ProductProffView.vue?vue&type=template&id=4f7f6144&ts=true"
import script from "./ProductProffView.vue?vue&type=script&lang=ts"
export * from "./ProductProffView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__